import { render, staticRenderFns } from "./NewStack.vue?vue&type=template&id=0e48c0fd&scoped=true&"
import script from "./NewStack.vue?vue&type=script&lang=js&"
export * from "./NewStack.vue?vue&type=script&lang=js&"
import style0 from "./NewStack.vue?vue&type=style&index=0&id=0e48c0fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e48c0fd",
  null
  
)

export default component.exports